import { render, staticRenderFns } from "./weekly-report-download.vue?vue&type=template&id=6022e36c&scoped=true"
import script from "./weekly-report-download.vue?vue&type=script&lang=js"
export * from "./weekly-report-download.vue?vue&type=script&lang=js"
import style0 from "./weekly-report-download.vue?vue&type=style&index=0&id=6022e36c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6022e36c",
  null
  
)

export default component.exports